import logo from "../rowlygo_logo_lila_rgb.png"; // Tell webpack this JS file uses this image
import { getImgHostingUrl } from "../utilities";
export default function UrentLogo() {
  return (
    <>
      <a
        style={{ fontSize: "13px", textDecoration: "none", color: "black" }}
        href="https://rowlygo.fi"
        target="_blank"
      >
        <div>
          <img
            style={{
              height: "45px",
              objectFit: "contain",
            }}
            src={getImgHostingUrl(logo)}
            alt="Powered by uRent"
          />
        </div>
      </a>
    </>
  );
}
